import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar.jsx';
import Header from './Header.jsx';
import { useVersionInfo } from '../../hooks/useVersionInfo.js';

function buildTooltip({ commit, builtAt }) {
  const parts = [];
  if (commit && commit !== 'dev') parts.push(`Commit: ${commit}`);
  if (builtAt) parts.push(`Built: ${builtAt}`);
  parts.push(`\u00a9 ${new Date().getFullYear()} Colorado Communications`);
  return parts.join('\n');
}

export default function AppShell() {
  const { data } = useVersionInfo();
  const version = data?.version || 'dev';
  const tooltip = buildTooltip(data || {});

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
        <footer className="flex items-center justify-between border-t border-gray-200 bg-white px-6 py-2 text-xs text-gray-400">
          <span title={tooltip} className="cursor-default">
            VISTA Admin Console {version} · Colorado Communications
          </span>
        </footer>
      </div>
    </div>
  );
}
